@import "../../sass/variables/variables";

.uxn-notification-text {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
}

.uxn-notification-text__wrapper_expanded {
	max-height: unset !important;
	overflow: unset !important;
}

.uxn-notification-text__wrapper_gradient::before {
	content: "";
	width: 100%;
	height: 114px;
	@media (min-width: 1200px) {
		height: 150px;
	}
	position: absolute;
	left: 0;
	top: 0;
	background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}

.uxn-notification-text__icon {
	transform: rotate(180deg);
}

.uxn-notification-text__wrapper {
	display: flex;
	flex-direction: column;
	margin-left: 5px;
	max-height: 114px;
	@media (min-width: 1200px) {
		max-height: 150px;
	}
	overflow: hidden;

	.uxn-notification-text__error {
		@include font(light);

		color: $color-red-error;
		font-size: $size-text-small;
		margin-bottom: 5px;
		text-transform: uppercase;
	}

	.uxn-notification-text__subject {
		margin-bottom: 4px;
		@media (min-width: 1200px) {
			margin-bottom: 6px;
		}
	}

	.uxn-notification-text__message {
		color: var(--uxn-notification-item-text-color);

		.uxn-text-link {
			white-space: nowrap;
		}
	}
}

// Severity modifier
.uxn-notification-item--information {
	.uxn-notification-text__subject {
		color: $color-black;
	}
}

.uxn-notification-item--warning {
	.uxn-notification-text__subject {
		color: $color-orange;
	}
}

.uxn-notification-item--error {
	.uxn-notification-text__subject {
		color: $color-red;
	}
}
